import { Box, TextField, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: 12,
  },
  label: {
    marginBottom: 6,
    fontSize: 12,
    fontWeight: 600,
    color: "var(--adm-text-muted)",
  },
  labelError: {
    color: "#d92d20",
  },
  customTextField: {
    "& .MuiOutlinedInput-root": {
      height: "100%",
      borderRadius: 10,
      backgroundColor: "var(--adm-surface)",
      fontSize: 13,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--adm-border)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#dcdfe6",
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--adm-dark)",
    },
  },
  singleLine: {
    height: 42,
  },
}));

const CustomTextBox = ({
  label,
  onChange,
  value,
  error,
  InputProps,
  rows,
  inputRef,
  onKeyDown,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography
        variant={"h6"}
        className={clsx({
          [classes.label]: true,
          [classes.labelError]: error,
        })}
      >
        {label}
      </Typography>
      <TextField
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={clsx({
          [classes.customTextField]: true,
          [classes.singleLine]: !rows,
        })}
        error={error}
        inputRef={inputRef}
        onKeyDown={onKeyDown}
        InputProps={InputProps}
        // multiline={rows}
        rows={4}
      />
    </Box>
  );
};

export default CustomTextBox;
